import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, PackageCheck } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden mb-[15px]" data-id="element-170">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand/20 blur-[120px] rounded-full pointer-events-none" data-id="element-171" />

      <div className="max-w-4xl mx-auto text-center relative z-10 mt-[-60px] mb-[-60px]" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center space-x-2 bg-dark-card border border-dark-border px-4 py-2 rounded-full mb-8" data-id="element-173">
          <span className="text-xl" data-id="element-174"></span>
          <span className="text-sm font-bold tracking-widest text-gray-300" data-id="element-175">
            ULTRAPACK DIGITAL™
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="md:text-5xl font-black tracking-tight mb-6 text-[32px] mt-[-30px]" data-id="element-176">
          Tu negocio de Desayunos Sorpresa.
          <br data-id="element-177" />
          <span className="text-brand" data-id="element-178">Listo. Desde hoy.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex justify-center mb-8" data-id="element-179">
          <img src="https://cdn.magicpatterns.com/uploads/1eTPfdGyTXwVyrDwKAzMpS/mockup.png" alt="Ultrapack Desayunos Rentables" className="max-w-lg w-full mt-[-20px] mb-[-20px]" data-id="element-180" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mb-10 max-w-2xl mx-auto" data-id="element-181">
          <p className="text-lg text-brand mb-2" data-id="element-182">
            Sin perder plata comprando de más. Sin miedo a la inflación.
          </p>
          <p className="text-lg text-white mt-[0px] mb-[-20px]" data-id="element-183">
            Combos + Costos + Contenido + Ventas listos para usar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-nowrap justify-center gap-2 mb-[20px]" data-id="element-184">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso 5 min'
        }, {
          icon: PackageCheck,
          text: 'Sistema Completo'
        }].map((badge, i) => <div key={i} className="flex items-center space-x-1.5 bg-dark-card border border-dark-border px-2 py-1 rounded-md text-xs text-gray-300" data-id="element-185">
              <badge.icon className="w-3.5 h-3.5 text-brand" data-id="element-186" />
              <span className="text-[10px]" data-id="element-187">{badge.text}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-188">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-brand hover:bg-brand-dark text-white text-lg font-bold py-5 px-10 rounded-xl shadow-[0_0_40px_rgba(249,115,22,0.4)] transition-all hover:scale-105 hover:shadow-[0_0_60px_rgba(249,115,22,0.6)] flex items-center justify-center space-x-3" data-id="element-189">
            <span className="text-[17px]" data-id="element-190">QUIERO MI ULTRAPACK AHORA</span>
          </button>

          <div className="flex items-center justify-center flex-wrap gap-4 mt-6 text-gray-400 text-xs font-medium" data-id="element-191">
            <div className="flex items-center space-x-1" data-id="element-192">
              <span data-id="element-193">🛡️</span>
              <span data-id="element-194">Garantía 7 días</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-195">
              <span data-id="element-196">🔒</span>
              <span data-id="element-197">Pago seguro</span>
            </div>
            <div className="flex items-center space-x-1" data-id="element-198">
              <span data-id="element-199">💳</span>
              <span data-id="element-200">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}